(() => {
  const targetPath = '/products/moduplant-200';
  const normalisedPath = window.location.pathname.replace(/\/$/, '');
  if (!normalisedPath.endsWith(targetPath)) return;

  document.documentElement.classList.add('moduflow-moduplant-200');

  const icons = {
    magnet: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3v8a6 6 0 0 0 12 0V3h-4v8a2 2 0 0 1-4 0V3H6Z"/><path d="M6 7h4M14 7h4"/></svg>',
    planter: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 10h12l-1.4 10H7.4L6 10Z"/><path d="M12 10V5"/><path d="M12 7c-2.8 0-4.5-1.3-4.5-3.5C10.3 3.5 12 4.8 12 7Z"/><path d="M12 8c2.8 0 4.5-1.3 4.5-3.5C13.7 4.5 12 5.8 12 8Z"/></svg>',
    reconfigure: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="6" height="6" rx="1.2"/><rect x="15" y="3" width="6" height="6" rx="1.2"/><rect x="3" y="15" width="6" height="6" rx="1.2"/><rect x="15" y="15" width="6" height="6" rx="1.2"/><path d="M10.5 6h3M12.5 4l2 2-2 2M13.5 18h-3M11.5 20l-2-2 2-2"/></svg>',
    bristol: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z"/><circle cx="12" cy="10" r="2.2"/><path d="M8.5 21h7"/></svg>'
  };

  const iconCards = [
    ['Made with care', 'Magnetic connection', icons.magnet],
    ['Great value', 'Planter or organiser', icons.planter],
    ['Elegant design', 'Reconfigurable system', icons.reconfigure],
    ['Quality materials', 'Batch made in Bristol', icons.bristol]
  ];

  const findExact = (selector, text, root = document) =>
    [...root.querySelectorAll(selector)].find((element) => element.textContent.trim() === text);

  const setSummaryLabel = (summary, label) => {
    const textNode = [...summary.childNodes].find(
      (node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()
    );
    if (textNode) {
      textNode.nodeValue = ` ${label} `;
      return;
    }
    const marker = summary.querySelector('.icon-caret, .icon-plus');
    summary.insertBefore(document.createTextNode(` ${label} `), marker || null);
  };

  const setAccordionContent = (details, html) => {
    const content = details.querySelector('.details-content');
    if (!content) return;
    content.innerHTML = `<div class="moduflow-accordion-copy">${html}</div>`;
  };

  const applyChanges = () => {
    let changed = false;

    iconCards.forEach(([oldLabel, newLabel, svg]) => {
      const label = findExact('p', oldLabel);
      if (!label) return;
      label.textContent = newLabel;
      const card = label.closest('.group-block');
      if (card) {
        card.classList.add('moduflow-icon-card');
        const iconBlock = card.querySelector('.icon-block');
        if (iconBlock) iconBlock.innerHTML = svg;
      }
      changed = true;
    });

    const accordion = document.querySelector('.accordion');
    if (!accordion) return changed;

    const detailRows = [...accordion.querySelectorAll('details')];
    const howItWorks = detailRows.find((row) =>
      row.querySelector('summary')?.textContent.trim().startsWith('Details')
    );
    const originalShipping = detailRows.find((row) =>
      row.querySelector('summary')?.textContent.trim().startsWith('Shipping & Returns')
    );

    if (howItWorks && !howItWorks.dataset.moduflowUpdated) {
      setSummaryLabel(howItWorks.querySelector('summary'), 'How it works');
      setAccordionContent(
        howItWorks,
        '<p>Built-in magnets on each side allow MODUflow modules to click together securely. Use MODUplant 200 on its own or combine it with other modules in different configurations, then rearrange the setup as your workspace changes.</p><p>Use it as a planter or as a stationery organiser for pens, markers and other desk tools.</p>'
      );
      howItWorks.dataset.moduflowUpdated = 'true';
      changed = true;
    }

    if (originalShipping && !originalShipping.dataset.moduflowUpdated) {
      setSummaryLabel(originalShipping.querySelector('summary'), 'Materials & manufacture');
      setAccordionContent(
        originalShipping,
        '<p>The outer housing and planter are made from PLA, a bio-based plastic derived from renewable plant sources. The removable inner pot and connection ring are PETG.</p><p>A satin-black powder-coated steel base adds weight and stability. Each product is 3D printed and assembled in small batches in Bristol, with the steel base manufactured in South Wales.</p>'
      );
      originalShipping.dataset.moduflowUpdated = 'true';

      const existingShipping = accordion.querySelector('[data-moduflow-shipping]');
      if (!existingShipping) {
        const wrapper = originalShipping.closest('accordion-custom');
        if (wrapper) {
          const shippingWrapper = wrapper.cloneNode(true);
          shippingWrapper.dataset.moduflowShipping = 'true';
          shippingWrapper.removeAttribute('open');
          const shippingDetails = shippingWrapper.querySelector('details');
          shippingDetails?.removeAttribute('open');
          if (shippingDetails) {
            delete shippingDetails.dataset.moduflowUpdated;
            setSummaryLabel(shippingDetails.querySelector('summary'), 'Shipping & returns');
            setAccordionContent(
              shippingDetails,
              '<p>MODUplant 200 is batch made in Bristol. Please allow 7–10 working days for your order to be produced, checked and dispatched.</p><p>To request a return, contact the MODUflow team and each request will be reviewed with care.</p>'
            );
          }
          wrapper.after(shippingWrapper);
        }
      }
      changed = true;
    }

    return changed;
  };

  const run = () => applyChanges();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  [250, 750, 1500].forEach((delay) => window.setTimeout(run, delay));
})();
